module.exports = __webpack_public_path__ + "media/images/lb/479-36d82ea5df1765cf8df69c522020b47c.svg";